import beamEnv from '@beam-australia/react-env';
import { get } from 'lodash';

const env = (name) => beamEnv(name) || get(process.env, name);

const stripReactAppPrefix = (st) => st.replace('REACT_APP_', '');

export const stripReactPrefixes = (envsObj) => Object.keys(envsObj).reduce((acc, key) => {
  acc[stripReactAppPrefix(key)] = envsObj[key];
  return acc;
}, {});

/* eslint-disable no-underscore-dangle */
export const all = () => {
  if (typeof window !== 'undefined' && window._env) {
    return {
      ...process.env,
      ...stripReactPrefixes(window._env)
    };
  }
  return {
    ...process.env
  };
};
window._getEnv = env;
window._allEnv = all;

export default env;
